import { render, staticRenderFns } from "./CoronarografiaPtcaViewComponent.vue?vue&type=template&id=4daa5c88"
import script from "./CoronarografiaPtcaViewComponent.vue?vue&type=script&lang=js"
export * from "./CoronarografiaPtcaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports